import { PostMessageType } from '../constants/postMessage';
import { safePostMessage } from './index';

export const cleanMarkdownUrl = (value?: string): string => {
  if (!value || typeof value !== 'string') return '';
  const trimmed = value.trim();
  const match = trimmed.match(/^\[[^\]]*\]\((.*?)\)$/);
  return (match ? match[1] : trimmed).trim();
};

export const isDeeplinkUrl = (url?: string): boolean => {
  if (!url || typeof url !== 'string') return false;
  const trimmed = cleanMarkdownUrl(url);
  if (!trimmed || trimmed === '#' || trimmed.startsWith('javascript:')) return false;
  return !/^https?:\/\//i.test(trimmed);
};

export const extractDeeplinkRoute = (rawUrl: string): string => {
  const trimmed = cleanMarkdownUrl(rawUrl);
  try {
    const parsed = new URL(trimmed);
    return parsed.pathname + parsed.search + parsed.hash;
  } catch {
    return trimmed;
  }
};

export const dispatchDeeplink = (url: string, onNavigate?: () => void): void => {
  const routePath = extractDeeplinkRoute(url);
  console.log('[Deeplink] NAVIGATE_ROUTE ->', routePath);
  setTimeout(() => {
    safePostMessage({ type: PostMessageType.NAVIGATE_ROUTE, payload: routePath });
    safePostMessage({ type: PostMessageType.CHAT_TOGGLE, isOpen: false });
    onNavigate?.();
  }, 100);
};

export const openWebUrl = (url: string): void => {
  try {
    const parsed = new URL(url);
    if (!['http:', 'https:'].includes(parsed.protocol)) return;
    window.open(parsed.toString(), '_blank', 'noopener,noreferrer');
  } catch {
    return;
  }
};

export const openChatLink = (url?: string, onNavigate?: () => void): void => {
  const cleanUrl = cleanMarkdownUrl(url);
  if (!cleanUrl || cleanUrl === '#' || cleanUrl.startsWith('javascript:')) return;
  if (isDeeplinkUrl(cleanUrl)) {
    dispatchDeeplink(cleanUrl, onNavigate);
    return;
  }
  openWebUrl(cleanUrl);
};

export const linkTextParts = (text?: string): [string, string] => {
  if (!text || typeof text !== 'string') return ['', ''];
  const index = text.toLocaleLowerCase('vi').lastIndexOf('tại đây');
  if (index < 0) return [text, ''];
  const wrapped = text.slice(index - 2, index) === '**' && text.slice(index + 7, index + 9) === '**';
  const start = wrapped ? index - 2 : index;
  return [text.slice(0, start), text.slice(index + (wrapped ? 9 : 7))];
};

